/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Icon } from '../../../common/iconSettings';
import { NgForm } from '@angular/forms';
import { WorkflowService } from '../../services/workflow.service';
import { ProductPlanTier, UserService } from '../../services/user.service';

@Component({
  selector: 'save-as-new-modal-component',
  templateUrl: './save-as-new-modal.component.html',
  styleUrls: ['./save-as-new-modal.component.less'],
  standalone: false,
})
export class SaveAsNewModalComponent implements OnInit {
  @Input() name: string;
  @Input() private = false;
  @Input() icon: Icon;
  @Input() saveAsNew = false;

  error: string;
  options = [
    { value: true, SDE_KEY: 'SDE_USE_EXISTING_ICON', isChecked: false },
    { value: false, SDE_KEY: 'SDE_PICK_ICON', isChecked: false },
  ];
  selected = this.options[0];
  saves = [
    { value: true, SDE_KEY: 'SDE_SAVE', isChecked: false },
    { value: false, SDE_KEY: 'SDE_SAVE_AS_NEW', isChecked: false },
  ];
  selectedSave = this.saves[0];
  public = !this.private;
  allowSharing = false;
  customIcon = false;
  originalName: string;

  constructor(
    public activeModal: NgbActiveModal,
    private workflowService: WorkflowService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.allowSharing =
      (this.userService?.user?.acquisition?.productPlanTier &&
        this.userService.user.acquisition.productPlanTier >=
          ProductPlanTier.Advanced) ||
      false;
    if (!this.allowSharing) {
      this.public = false;
    } else {
      this.public = !this.private;
    }
    this.originalName = this.name;
  }

  privateToggle(event: boolean, f: NgForm) {
    setTimeout(() => {
      this.error = '';
    });
    f.form.get('name')?.setErrors({});
    f.form.get('name')?.updateValueAndValidity();
  }

  save(f: NgForm) {
    this.error = '';

    f.form.get('name')?.markAsTouched();
    f.form.get('name')?.markAsDirty();

    this.name = this.name.trim();
    if (!this.name.replace(/\s/g, '').length) {
      return;
    }
    if (
      ((this.saveAsNew ||
        !this.selectedSave.value ||
        (this.selectedSave.value &&
          this.name.toLocaleLowerCase() !== this.originalName.toLowerCase())) &&
        this.workflowService.isWorkflowWithSameNameExist(
          !this.public,
          this.name,
        )) ||
      (this.private == this.public &&
        this.workflowService.isWorkflowWithSameNameExist(
          !this.public,
          this.name,
        ))
    ) {
      // Only display the same name error if the name is repeated in a Save As New mode or if it is repeated in a save mode for a public workflow being saved a private workflow or vice versa.
      // Don't allow Save if the name has changed and it already exists.
      setTimeout(() => {
        this.error = 'SDE_WORKFLOW_BY_NAME';
      });
      f.form.get('name')?.setErrors({ customerror: true });
    } else {
      this.activeModal.close({
        name: this.name.replace(/</g, '&lt;').replace(/>/g, '&gt;'),
        private: !this.public,
        icon: this.icon,
        isDefaultIcon: this.selected.value,
        saveAsNew: this.saveAsNew || !this.selectedSave.value,
      });
    }
  }
}
